import { STARTER } from 'self-service-api/constants/ProductLevels';
import { BUY_TOUCHLESS, CALCULATE_PRICE } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import { hasHigherProductLevelInProductInventorySelector, hasProductInProductInventorySelector } from './ProductInventorySelectors';
import { crmSuiteProductLinesForProductLevelSelector, currentSuiteSkuIdsForProductLevelSelector } from './ProductsSelectors';
import { purchaseMotionsSelector } from './PurchaseMotionSelectors';
export const canUpgradeToProductLevelSuiteSelector = (state, {
  productLevel
}) => {
  const ownsHigherProductLevel = hasHigherProductLevelInProductInventorySelector(state, {
    productLevel
  });
  const crmSuiteProductsForProductLevel = crmSuiteProductLinesForProductLevelSelector(state, {
    productLevel
  });
  const ownsAllProductLinesInProductLevel = crmSuiteProductsForProductLevel.every(productLine => hasProductInProductInventorySelector(state, {
    productAttributeFilters: {
      productLine,
      productLevel
    }
  }));
  const starterSkuIds = currentSuiteSkuIdsForProductLevelSelector(state, {
    productLevel: STARTER
  });
  const cannotPurchaseAnyStarterSkusTouchlessly = starterSkuIds.filter(skuId => skuId).every(skuId => {
    const purchaseMotions = purchaseMotionsSelector(state, {
      skuId
    });
    return !purchaseMotions.includes(BUY_TOUCHLESS) && !purchaseMotions.includes(CALCULATE_PRICE);
  });
  return !(ownsHigherProductLevel || ownsAllProductLinesInProductLevel || cannotPurchaseAnyStarterSkusTouchlessly);
};